import { Alert, Box } from "@chakra-ui/react";
import { getSparkRegistrationErrorMessage } from "../../../lib/error-translators/getSparkRegistrationErrorMessage";
import { getSignUpErrorMessage } from "../../../lib/error-translators/getSignUpErrorMessage";
import { getSparkWaitlistErrorMessage } from "../../../lib/error-translators/getSparkWaitlistErrorMessage";

type ReqError = { code: string; params?: Record<string, unknown> } | null;

interface ErrorAlertsProps {
  register: ReqError;
  signup: ReqError;
  waitlist: ReqError;
  saveAttribute: ReqError;
}

const messages = (props: ErrorAlertsProps) =>
  [
    props.register &&
      getSparkRegistrationErrorMessage(
        props.register.code,
        props.register.params
      ),
    props.signup && getSignUpErrorMessage(props.signup.code),
    props.waitlist && getSparkWaitlistErrorMessage(props.waitlist.code),
    props.saveAttribute &&
      "Something went wrong saving information to your account.",
  ].filter(Boolean) as string[];

export const ErrorAlerts = (props: ErrorAlertsProps) => {
  const items = messages(props);
  if (!items.length) return null;
  return (
    <Box px="20px" mt="8px" display="flex" flexDirection="column" gap="8px">
      {items.map((m, i) => (
        <Alert.Root key={i} status="error" borderRadius="md">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Title>{m}</Alert.Title>
          </Alert.Content>
        </Alert.Root>
      ))}
    </Box>
  );
};
